module.exports = __webpack_public_path__ + "img/bitmex.adec8527.svg";